export default __webpack_public_path__ + "static/illustration-db51af474ea484a5c6f60a93d0ce122d.png";